import { appConstants } from "../../../action-constants/inapp.constants";

let userLogged = localStorage.getItem("mamiVXAuth") || "{}";

let user = JSON.parse(userLogged);

const initialState =
  Object.keys(user).length >= 1
    ? { loggedIn: true, user }
    : { loggedIn: false };

export const createStoreProductReducer = (
  state = initialState,
  action: any
) => {
  // export const forgotPasswordReducer = ({state=initialState, action}:ReducerParams)=>{
  switch (action.type) {
    case appConstants.CREATE_PRODUCT_PENDING:
      return {
        request_status: appConstants.CREATE_PRODUCT_PENDING,
        is_request_processing: true,
        request_data: action,
      };
    case appConstants.CREATE_PRODUCT_SUCCESS:
      return {
        request_status: appConstants.CREATE_PRODUCT_SUCCESS,
        is_request_processing: false,
        request_data: action,
      };
    case appConstants.CREATE_PRODUCT_FAILURE:
      return {
        request_status: appConstants.CREATE_PRODUCT_FAILURE,
        is_request_processing: false,
        request_data: action,
      };
    case appConstants.CREATE_PRODUCT_RESET:
      return {
        request_status: appConstants.CREATE_PRODUCT_RESET,
        is_request_processing: false,
        request_data: {},
      };

    default:
      return { ...state };
  }
};

export const uploadStoreBulkProductsReducer = (
  state = initialState,
  action: any
) => {
  // export const forgotPasswordReducer = ({state=initialState, action}:ReducerParams)=>{
  switch (action.type) {
    case appConstants.UPLOAD_MULTIPLE_PENDING:
      return {
        request_status: appConstants.UPLOAD_MULTIPLE_PENDING,
        is_request_processing: true,
        request_data: action,
      };
    case appConstants.UPLOAD_MULTIPLE_SUCCESS:
      return {
        request_status: appConstants.UPLOAD_MULTIPLE_SUCCESS,
        is_request_processing: false,
        request_data: action,
      };
    case appConstants.UPLOAD_MULTIPLE_FAILURE:
      return {
        request_status: appConstants.UPLOAD_MULTIPLE_FAILURE,
        is_request_processing: false,
        request_data: action,
      };
    case appConstants.UPLOAD_MULTIPLE_RESET:
      return {
        request_status: appConstants.UPLOAD_MULTIPLE_RESET,
        is_request_processing: false,
        request_data: {},
      };

    default:
      return { ...state };
  }
};

export const updateStoreProductReducer = (
  state = initialState,
  action: any
) => {
  // export const forgotPasswordReducer = ({state=initialState, action}:ReducerParams)=>{
  switch (action.type) {
    case appConstants.UPDATE_PRODUCT_PENDING:
      return {
        request_status: appConstants.UPDATE_PRODUCT_PENDING,
        is_request_processing: true,
        request_data: action,
      };
    case appConstants.UPDATE_PRODUCT_SUCCESS:
      return {
        request_status: appConstants.UPDATE_PRODUCT_SUCCESS,
        is_request_processing: false,
        request_data: action,
      };
    case appConstants.UPDATE_PRODUCT_FAILURE:
      return {
        request_status: appConstants.UPDATE_PRODUCT_FAILURE,
        is_request_processing: false,
        request_data: action,
      };
    case appConstants.UPDATE_PRODUCT_RESET:
      return {
        request_status: appConstants.UPDATE_PRODUCT_RESET,
        is_request_processing: false,
        request_data: {},
      };

    default:
      return { ...state };
  }
};

export const bulkProductUpdateReducer = (state = initialState, action: any) => {
  // export const forgotPasswordReducer = ({state=initialState, action}:ReducerParams)=>{
  switch (action.type) {
    case appConstants.BULK_UPDATE_PENDING:
      return {
        request_status: appConstants.BULK_UPDATE_PENDING,
        is_request_processing: true,
        request_data: action,
      };
    case appConstants.BULK_UPDATE_SUCCESS:
      return {
        request_status: appConstants.BULK_UPDATE_SUCCESS,
        is_request_processing: false,
        request_data: action,
      };
    case appConstants.BULK_UPDATE_FAILURE:
      return {
        request_status: appConstants.BULK_UPDATE_FAILURE,
        is_request_processing: false,
        request_data: action,
      };
    case appConstants.BULK_UPDATE_RESET:
      return {
        request_status: appConstants.BULK_UPDATE_RESET,
        is_request_processing: false,
        request_data: {},
      };

    default:
      return { ...state };
  }
};

export const updateProductImageReducer = (
  state = initialState,
  action: any
) => {
  // export const forgotPasswordReducer = ({state=initialState, action}:ReducerParams)=>{
  switch (action.type) {
    case appConstants.UPLOAD_PRODUCT_PICTURE_PENDING:
      return {
        request_status: appConstants.UPLOAD_PRODUCT_PICTURE_PENDING,
        is_request_processing: true,
        request_data: action,
      };
    case appConstants.UPLOAD_PRODUCT_PICTURE_SUCCESS:
      return {
        request_status: appConstants.UPLOAD_PRODUCT_PICTURE_SUCCESS,
        is_request_processing: false,
        request_data: action,
      };
    case appConstants.UPLOAD_PRODUCT_PICTURE_FAILURE:
      return {
        request_status: appConstants.UPLOAD_PRODUCT_PICTURE_FAILURE,
        is_request_processing: false,
        request_data: action,
      };
    case appConstants.UPLOAD_PRODUCT_PICTURE_RESET:
      return {
        request_status: appConstants.UPLOAD_PRODUCT_PICTURE_RESET,
        is_request_processing: false,
        request_data: {},
      };

    default:
      return { ...state };
  }
};

export const getProductListReducer = (state = initialState, action: any) => {
  // export const forgotPasswordReducer = ({state=initialState, action}:ReducerParams)=>{
  switch (action.type) {
    case appConstants.GET_PRODUCTS_PENDING:
      return {
        request_status: appConstants.GET_PRODUCTS_PENDING,
        is_request_processing: true,
        request_data: action,
      };
    case appConstants.GET_PRODUCTS_SUCCESS:
      return {
        request_status: appConstants.GET_PRODUCTS_SUCCESS,
        is_request_processing: false,
        request_data: action,
      };
    case appConstants.GET_PRODUCTS_FAILURE:
      return {
        request_status: appConstants.GET_PRODUCTS_FAILURE,
        is_request_processing: false,
        request_data: action,
      };
    case appConstants.GET_PRODUCTS_RESET:
      return {
        request_status: appConstants.GET_PRODUCTS_RESET,
        is_request_processing: false,
        request_data: {},
      };

    default:
      return { ...state };
  }
};

export const toggleProductReducer = (state = initialState, action: any) => {
  // export const forgotPasswordReducer = ({state=initialState, action}:ReducerParams)=>{
  switch (action.type) {
    case appConstants.TOGGLE_A_PRODUCT_PENDING:
      return {
        request_status: appConstants.TOGGLE_A_PRODUCT_PENDING,
        is_request_processing: true,
        request_data: action,
      };
    case appConstants.TOGGLE_A_PRODUCT_SUCCESS:
      return {
        request_status: appConstants.TOGGLE_A_PRODUCT_SUCCESS,
        is_request_processing: false,
        request_data: action,
      };
    case appConstants.TOGGLE_A_PRODUCT_FAILURE:
      return {
        request_status: appConstants.TOGGLE_A_PRODUCT_FAILURE,
        is_request_processing: false,
        request_data: action,
      };
    case appConstants.TOGGLE_A_PRODUCT_RESET:
      return {
        request_status: appConstants.TOGGLE_A_PRODUCT_RESET,
        is_request_processing: false,
        request_data: {},
      };

    default:
      return { ...state };
  }
};

export const getAProductReducer = (state = initialState, action: any) => {
  // export const forgotPasswordReducer = ({state=initialState, action}:ReducerParams)=>{
  switch (action.type) {
    case appConstants.GET_A_PRODUCT_PENDING:
      return {
        request_status: appConstants.GET_A_PRODUCT_PENDING,
        is_request_processing: true,
        request_data: action,
      };
    case appConstants.GET_A_PRODUCT_SUCCESS:
      return {
        request_status: appConstants.GET_A_PRODUCT_SUCCESS,
        is_request_processing: false,
        request_data: action,
      };
    case appConstants.GET_A_PRODUCT_FAILURE:
      return {
        request_status: appConstants.GET_A_PRODUCT_FAILURE,
        is_request_processing: false,
        request_data: action,
      };
    case appConstants.GET_A_PRODUCT_RESET:
      return {
        request_status: appConstants.GET_A_PRODUCT_RESET,
        is_request_processing: false,
        request_data: {},
      };

    default:
      return { ...state };
  }
};

export const getProductMetaDataReducer = (
  state = initialState,
  action: any
) => {
  // export const forgotPasswordReducer = ({state=initialState, action}:ReducerParams)=>{
  switch (action.type) {
    case appConstants.GET_PRODUCT_META_PENDING:
      return {
        request_status: appConstants.GET_PRODUCT_META_PENDING,
        is_request_processing: true,
        request_data: action,
      };
    case appConstants.GET_PRODUCT_META_SUCCESS:
      return {
        request_status: appConstants.GET_PRODUCT_META_SUCCESS,
        is_request_processing: false,
        request_data: action,
      };
    case appConstants.GET_PRODUCT_META_FAILURE:
      return {
        request_status: appConstants.GET_PRODUCT_META_FAILURE,
        is_request_processing: false,
        request_data: action,
      };
    case appConstants.GET_PRODUCT_META_RESET:
      return {
        request_status: appConstants.GET_PRODUCT_META_RESET,
        is_request_processing: false,
        request_data: {},
      };

    default:
      return { ...state };
  }
};

export const deleteStoreProductReducer = (
  state = initialState,
  action: any
) => {
  switch (action.type) {
    case appConstants.DELETE_A_PRODUCT_PENDING:
      return {
        request_status: appConstants.DELETE_A_PRODUCT_PENDING,
        is_request_processing: true,
        request_data: action,
      };
    case appConstants.DELETE_A_PRODUCT_SUCCESS:
      return {
        request_status: appConstants.DELETE_A_PRODUCT_SUCCESS,
        is_request_processing: false,
        request_data: action,
      };
    case appConstants.DELETE_A_PRODUCT_FAILURE:
      return {
        request_status: appConstants.DELETE_A_PRODUCT_FAILURE,
        is_request_processing: false,
        request_data: action,
      };
    case appConstants.DELETE_A_PRODUCT_RESET:
      return {
        request_status: appConstants.DELETE_A_PRODUCT_RESET,
        is_request_processing: false,
        request_data: {},
      };
    default:
      return { ...state };
  }
};


